import { addDays } from 'date-fns';

export const calculateCustomScheduleDate = (index: number, startDateStr?: string, freq?: string) => {
  if (!startDateStr) return undefined;
  const baseDate = new Date(startDateStr);
  
  let daysToAdd = 0;
  if (freq === 'Daily') daysToAdd = 1;
  if (freq === 'Weekly') daysToAdd = 7;
  if (freq === 'Biweekly') daysToAdd = 14;

  return addDays(baseDate, daysToAdd * index).toISOString();
}